// src/entities/authorComposer/components/common/DniFieldTick.tsx
import React from "react";
import { observer } from "mobx-react";
import { Box, Tooltip } from "@mui/material";
import { CheckCircleIcon } from "../../../../icons";
import { useRootStore } from "../../../../store/contexts";

/** El tic verde de un campo validado con el DNI; "Dato validado con DNI" al pasar el mouse. */
export const DniFieldTick: React.FC<{ visible: boolean }> = observer(({ visible }) => {
  const { langStore } = useRootStore();
  if (!visible) return null;
  return (
    <Tooltip title={langStore.authorDniValidatedField}>
      <Box
        component="span"
        role="img"
        aria-label={langStore.authorDniValidatedField}
        sx={{ display: "inline-flex", alignItems: "center", ml: 0.5 }}
      >
        <CheckCircleIcon color="success" fontSize="small" />
      </Box>
    </Tooltip>
  );
});
